export default {
  Empty: 'Select a playbook to view its details.',
  Edit: 'Edit',
  Delete: 'Delete',
  ActiveInstances: '#{number} active instance#{suffix}',
  TotalInstances: 'Used #{number} time#{suffix}',
  UpdatedAt: 'Updated #{date}',
  Description: 'Description',
  NoDescription: 'No description provided.',
  Steps: 'Steps',
  Rules: 'Rules',
};
